<template>
  <div class="text-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="240"
      open-on-click
      :close-on-click="closeOnClick"
      transition="slide-x-reverse-transition"
      right
      offset-y
      origin="center right"
    >
      <template style="" v-slot:activator="{ on }">
        <v-btn color="#008176" dark fab v-on="on">
          <v-icon>fas fa-angle-double-left</v-icon>
        </v-btn>
      </template>

      <!-- card desplegado -->
      <v-card
        style="
          display: flex !important;
          flex-direction: column;
          overflow: auto;
          border: none;
          height: calc(100vh - 50px);
        "
        dark
        width="300"
      >
        <v-list>
          <v-list-item>
            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn color="#008176" fab dark text @click="menu = false">
                <v-icon>fas fa-angle-double-right</v-icon>
              </v-btn>
            </v-card-actions>

            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title v-if="informacionElemento.nombre_asociado">
                  {{ informacionElemento.nombre_asociado }}</v-list-item-title
                >
                <v-list-item-title
                  v-else-if="!informacionElemento.nombre_asociado"
                >
                  Seleccione un elemento...</v-list-item-title
                >
                <v-list-item-subtitle v-if="informacionElemento">
                  ID : {{ informacionElemento.id_asociado }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list-item>
        </v-list>
        <div style="padding: 10px">
          <p v-if="informacionElemento">
            Valor: {{ informacionElemento.etiqueta }}
          </p>
          <p>Hace: {{ fechaUltimoEnvio }}</p>
          <!-- <p id="demo"></p> -->
        </div>
        <RightItemGroup />
      </v-card>
      <!-- card desplegado -->
    </v-menu>
  </div>
</template>

<script>
import RightItemGroup from "../RightItemGroup.vue";
import { formatDuration, intervalToDuration, isValid } from "date-fns";
import { es } from "date-fns/locale";

export default {
  components: { RightItemGroup },
  data: () => ({
    drawer: null,
    fav: true,
    menu: false,
    offset: false,
    closeOnClick: false,
  }),
  created() {},
  beforeDestroy() {},
  computed: {
    // nuevo
    informacionElemento() {
      return this.$store.state.aplicaciones.informacionElemento;
    },
    fechaUltimoEnvio() {
      
      if (this.informacionElemento.fecha) {
        if (isValid(new Date(this.informacionElemento.fecha))) {
           let duration = intervalToDuration({
          start: new Date(this.informacionElemento.fecha),
          end: new Date(),
        });
          return formatDuration(duration,{
            format: ['months', 'days', 'hours', 'minutes'],
            delimiter: ", ", locale: es
          });
        }else{
          return this.informacionElemento.fecha
        }
       
      } else {
        return '';
      }
    },
    etiquetaNodo() {
      return this.$store.state.aplicaciones.nombreNodo;
    },
    idNodo() {
      return this.$store.state.aplicaciones.idNodo;
    },

    aplicacionesCliente() {
      return this.$store.state.aplicaciones.aplicacionesCliente;
    },
  },
  methods: {},
};
</script>

<style>
</style>